import { render, staticRenderFns } from "./FacultyDetail.vue?vue&type=template&id=74b8a95a"
import script from "./FacultyDetail.vue?vue&type=script&lang=ts"
export * from "./FacultyDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports